import { Box, BoxProps } from '@osmosis/tailwind-ui/components/Box';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import { bgPurple } from '@osmosis/tailwind-ui/styles/background';
import { text0 } from '@osmosis/tailwind-ui/styles/text';
import { HTMLAttributes, ReactNode } from 'react';

type Props = {
  content: ReactNode;
  dataTestId: string;
  containerProps?: BoxProps;
  labelProps?: HTMLAttributes<HTMLSpanElement>;
};

const labelClasses = `${bgPurple} flex items-center justify-center rounded font-bold ${text0} p-2 text-xs h-5 min-w-10`;

/**
 * Renders a non-interactive label pill.
 */
export const LabelComponent = (props: Props) => {
  const { content, dataTestId, containerProps = {}, labelProps = {} } = props;
  const { className, ...restLabelProps } = labelProps;

  return (
    <Box
      data-testid="label.wrapper"
      style={{
        overflowWrap: 'break-word',
      }}
      {...containerProps}
    >
      <span
        data-testid={dataTestId}
        className={cn(labelClasses, className)}
        {...restLabelProps}
      >
        {content}
      </span>
    </Box>
  );
};
